module.exports = __webpack_public_path__ + "static/media/icon_22.9189c4aa.svg";